import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByCategories(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_FINANCE_BY_CATEGORIES,dtConfig[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES].getReportsFinanceByCategories,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsFinanceByCategories,
}
